export const DEFAULT_PER_PAGE_TEAM_LANDING = 50;

export const GET_TEAM_LANDING = 'get_team_landing';
export const GET_TEAM_MEMBER_BY_ID_LANDING = 'get_team_member_by_id_landing';
export const CLEAR_TEAM_MEMBER_BY_ID_LANDING =
  'clear_team_member_by_id_landing';
